import { render } from "./RelatorioContratosAVencerView.vue?vue&type=template&id=b1a6a6bc"
import script from "./RelatorioContratosAVencerView.vue?vue&type=script&lang=js"
export * from "./RelatorioContratosAVencerView.vue?vue&type=script&lang=js"

import "./RelatorioContratosAVencerView.vue?vue&type=style&index=0&id=b1a6a6bc&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__